import React from 'react';
import { DefaultButton } from '@fluentui/react';
import styles from './TableInfoBar.module.css';

interface TableInfoBarProps {
  loading?: boolean;
  showingRange: { start: number; end: number };
  totalCount: number;
  filteredCount: number;
  filtersSummary?: string;
  sortSummary?: string;
  onClearFilters?: () => void;
  onRefresh?: () => void;
  onExportCsv?: () => void;
}

export const TableInfoBar: React.FC<TableInfoBarProps> = ({
  loading = false,
  showingRange,
  totalCount,
  filteredCount,
  filtersSummary,
  sortSummary,
  onClearFilters,
  onRefresh,
  onExportCsv,
}) => {
  const filtersLabel = filtersSummary && filtersSummary.trim().length > 0 ? filtersSummary : 'None';
  const rangeText = `Showing ${showingRange.start}-${showingRange.end} of ${totalCount}`;
  const countText = filteredCount !== totalCount ? `${rangeText} (filtered)` : rangeText;

  return (
    <div className={styles.infoBar} aria-live="polite">
      <div className={styles.metrics}>
        <div className={loading ? styles.skeleton : styles.metricText}>{countText}</div>
        <div className={loading ? styles.skeletonSmall : styles.metricText}>
          Filters: {filtersLabel}
        </div>
        {sortSummary ? (
          <div className={loading ? styles.skeletonSmall : styles.metricText}>
            Sort: {sortSummary}
          </div>
        ) : null}
      </div>
      <div className={styles.actions}>
        {onClearFilters ? (
          <DefaultButton
            text="Clear filters"
            onClick={onClearFilters}
            disabled={loading || filtersLabel === 'None'}
          />
        ) : null}
        {onRefresh ? (
          <DefaultButton text="Refresh" onClick={onRefresh} disabled={loading} />
        ) : null}
        {onExportCsv ? (
          <DefaultButton text="Export CSV" onClick={onExportCsv} disabled={loading} />
        ) : null}
      </div>
    </div>
  );
};
